import { CHANGE_REQUEST_TABS } from './constants';

function panelSnapshotFromResponse(data) {
  if (!data || typeof data !== 'object') {
    return { panelDataFetchedAt: null, panelPendingSnapshot: null };
  }
  return {
    panelDataFetchedAt:
      data.panelDataFetchedAt ?? data.panel_data_fetched_at ?? null,
    panelPendingSnapshot:
      data.panelPendingSnapshot ?? data.panel_pending_snapshot ?? null,
  };
}

export default function normalizeChangeRequestPanelPayload(data) {
  if (!data || typeof data !== 'object') {
    return data;
  }
  const incoming = data.categoriesByTab || {};
  const categoriesByTab = CHANGE_REQUEST_TABS.reduce((acc, tabId) => {
    const bucket = incoming[tabId];
    if (bucket && typeof bucket === 'object') {
      acc[tabId] = {
        ...bucket,
        sections:
          bucket.sections && typeof bucket.sections === 'object'
            ? bucket.sections
            : {},
      };
    } else {
      acc[tabId] = { sections: {} };
    }
    return acc;
  }, {});

  const snapshotMeta = panelSnapshotFromResponse(data);

  return {
    ...data,
    ...snapshotMeta,
    categoriesByTab,
  };
}
